import React from 'react';
import Layout from "./Layout/Layout";
import "../../../assets/scss/dashboard.scss";
import { DashboardContextProvider } from "./Context/DashboardContext";

const Dashboard = props => <DashboardContextProvider >
    <Layout farmId={props.match.params.farmId} {...props} />
</DashboardContextProvider>

export default Dashboard;